var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$auth.ready())?_c('div',[_c('router-view'),_vm._v(" "),_c('notifications-component')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }